import { connect } from 'react-redux';
import { getActiveStreamType } from '../redux/selectors';
import { switchStream } from '../redux/actionCreators';
import { EmoteStreamType } from '../redux/types';
var mapStateToProps = function (state) { return ({
    activeStream: getActiveStreamType(state) || EmoteStreamType.OFFICIAL,
}); };
var mapDispatchToProps = {
    switchStream: switchStream,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=TabsHeader.container.js.map